// components/VideoEmbed.js

const VideoEmbed = ({
  videoUrl = "https://www.youtube.com/embed/your-video-id",
}) => {
  return (
    <div className="video-container">
      {videoUrl ? (
        <video width="1280" height="720" controls>
          <source src={videoUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      ) : (
        <p>No video available</p>
      )}
    </div>
  );
};

export default VideoEmbed;
